import Router from 'vue-router';

// Framework
import {
    Home,
    ContractModal,
    UploadModal,
    ThanksModal,
    Profile,
} from '@skeepers/platform-framework/views/desktop';
import {
    NotFound,
    Forbidden,
} from '@skeepers/platform-framework/views/shared';
import {
    routerStrategy,
} from '@skeepers/platform-framework/data';

// Basic
import {
    BriefWrapper,
} from '@/views/desktop';
import {
    DepositWrapper,
} from '@/views/shared';

export default new Router({
    mode: 'history',
    base: routerStrategy('base') || '/',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: { tracking: 'PLATFORM_HOMEPAGE_VIEW' },
        }, {
            path: '/deposit',
            name: 'deposit',
            redirect: '/deposit/brief',
            component: DepositWrapper,
            meta: { auth: true },
            children: [
                {
                    path: '/deposit/brief',
                    name: 'deposit.brief',
                    component: BriefWrapper,
                    props: { next: 'deposit.contract' },
                    meta: { tracking: 'PLATFORM_BRIEF_VIEW' },
                    children: [
                        {
                            path: '/deposit/contract',
                            name: 'deposit.contract',
                            component: ContractModal,
                            props: { parent: 'deposit.brief', next: 'deposit.upload' },
                            meta: { tracking: 'PLATFORM_CONTRACT_VIEW' },
                        }, {
                            path: '/deposit/upload',
                            name: 'deposit.upload',
                            component: UploadModal,
                            props: { parent: 'deposit.brief', next: 'deposit.thanks' },
                            meta: { tracking: 'PLATFORM_UPLOAD_VIEW' },
                        }, {
                            path: '/deposit/thanks',
                            name: 'deposit.thanks',
                            component: ThanksModal,
                            props: { parent: 'deposit.brief' },
                            meta: { tracking: 'PLATFORM_THANKS_VIEW' },
                        },
                    ],
                },
            ],
        }, {
            path: '/profile',
            name: 'profile',
            component: Profile,
            meta: { auth: true },
        }, {
            path: '/forbidden',
            name: 'forbidden',
            component: Forbidden,
        }, {
            path: '*',
            name: 'not-found',
            component: NotFound,
        },
    ],
});
